/**
 * Small replacements for the most trivial lodash helpers (null-safe string coercion).
 * lodash `toString`: `null` / `undefined` → '' (unlike `String(null)` which is fine, but matches storefront usage).
 */
export function safeToString (value: unknown): string {
  if (value == null) return ''
  return String(value)
}

export function safeTrim (value: unknown): string {
  return safeToString(value).trim()
}
